import React, { ReactElement, ReactNode } from "react";
import RouteContext, { RouteParams } from "./paramrouting-context";

const ParamRouteProvider = ({ route, children }: { children: ReactNode; route: RouteParams }): ReactElement => {
  return <RouteContext.Provider value={route}>{children}</RouteContext.Provider>;
};

export default ParamRouteProvider;
